<template>
  <div class="result-table">
    <div class="result-table-wrap border border-top-0" dir="rtl">      
      <b-table-simple 
        small 
        responsive 
        sticky-header="73vh" 
        class="mb-0"
        >
        <b-thead>
          <b-tr>          
            <b-th 
              class="border-top text-left px-3 bg-white font-weight-normal" 
              :class="{'sticky':index==0, 'border-left':index!=fields.length-1}"
              v-for="(item, index) in fields" 
              :key="index">
              {{item}}
            </b-th>
          </b-tr>    
        </b-thead>
        <b-tbody v-if="udFormat">
          <b-tr v-for="(item, index) in tableDataUD" :key="index">    
            <b-td stickyColumn class="border-left px-3 text-right">          
              {{item.id}}
            </b-td>
            <b-td class="border-left px-3 text-right f-narkis">          
              {{item.word}}
            </b-td>
            <b-td class="border-left px-3 text-right f-narkis">          
              {{item.lemma}}
            </b-td>
            <b-td class="border-left px-3 text-right f-narkis">          
              {{item.lemmaVocalized}}
            </b-td>
            <b-td class="text-left border-left px-3 ">{{item.upos}}</b-td>
            <!--<b-td class="text-left border-left px-3 ">{{item.xpos}}</b-td>-->
            <b-td class="text-left p-0 pb-2">
              <small
                dir="ltr"
                v-for="(feature, i) in item.features" :key="i" 
                :class="{'bg-secondary' : feature.length > 1}"
                class = "feature-item rounded-pill px-3 py-1 ml-2 mt-2 d-inline-block"
                >{{feature}}
              </small>
            </b-td>        
          </b-tr>
        </b-tbody>
        <b-tbody v-else>
          <b-tr v-for="(item, index) in tableDataFiltered" :key="index">
            <b-td 
              v-for="(tableCell, i, counter) in item" 
              :stickyColumn="counter==0"
              :key="i"
              class="px-3" 
              :class="{'text-left':counter>3, 'f-narkis': counter < 4, 'border-left': counter!=fields.length-1}"
            >
              <span v-if="counter<2 && tableCell.includes('|')">
                <span class="prefix">{{tableCell.split('|')[0]}}<span class="prefix-line">|</span></span>{{tableCell.split('|')[1]}}
              </span>
              <span v-else>
                {{capitalize(tableCell)}}
              </span>  
            </b-td>
          </b-tr>
          <!--<b-tr v-if="bguLength > 100">
            <b-td colspan="17" class="text-right p-0">
              <div class="bg-white px-3 py-1">{{hebrew ? 'לפירוט המלא יש ללחוץ על כפתור ההורדה' : 'Click Download for the full analysis'}}</div>
            </b-td>
          </b-tr>-->
        </b-tbody>
      </b-table-simple>
    </div>
    <div class="my-2 d-flex justify-content-between align-items-center">
      <small 
        v-if="(bguLength > 100 && !udFormat )|| (udFormat && udLength < udOrgLength)" 
        class="d-block text-muted">
        {{hebrew ? 'לפירוט המלא יש ללחוץ על כפתור ההורדה' : 'Click Download for the full analysis'}}
      </small>
      <small class="d-block">{{textStyle}}</small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResultTable',
  data() {
    return {
      bguFields: [
        'Word',      
        'Menukad',
        'Lex',
        'Unvocalized',
        'POS',
        'Prefix',
        'Gender',
        'Number',
        'Person',
        'Status',
        'Tense',
        'Binyan',
        'Suffix',
        'Suf_Gender',
        'Suf_Person',
        'Suf_Number',
        'Aramaic'
      ], 
      udFields: [
        'ID',
        'Word',
        'Lemma',
        'LemmaVoc',
        'UPOS',
        //'XPOS',
        'Features'
      ]
    }
  },
  mounted () {
    //if no results, return to home page
    if (this.$store.state.results.length == 0)
      this.$router.push({ name: "Search" })
  },
  computed: {
    hebrew () {
      return this.$settings.hebrew
    },
    udFormat () {
      return this.$store.state.fileFormat.includes('UD')
    },
    fields () {
      return this.udFormat ? this.udFields : this.bguFields
    },
    tableOptions () {
      let data = this.$store.state.results[0].BGU.split('\n').slice(1, 101)
      return data.map(element=> {
        return element.split('\t').slice(4, 16)
      })
    },
    udLength () {
      //return this.$store.state.results[0] ? this.$store.state.results[0].UD.split('\n').length : 0
      return this.$store.state.UDarr.length
    },
    udOrgLength () {
      return this.$store.state.results[0].UD.split('\n').length
      //.filter(ln => {return !ln.includes('#')}).length
    },
    bguLength () {
      return this.$store.state.results[0] ? this.$store.state.results[0].BGU.split('\n').filter(el=>el).length-1 : 0
    },
    tableDataBGU ()  {
      if (this.$store.state.results[0] ) {
        let rows = this.$store.state.results[0].BGU.split('\n').slice(1, 101)
        return rows.map ((element) => {
          let row =  element.split('\t')
          let mrophObj = {}
          row.map ((morphElement, index) => {
            if (index < 17)
              mrophObj[this.fields[index]] = morphElement.replaceAll('""""', '"')//this.capitalize(morphElement)         
            //morph: row.slice(3,row.length-1).map(e => {return this.capitalize(e)}).filter(e => e).join(', '),
          
          })
          return mrophObj
       })   
        
      } else {
        return []
      } 
    },
    tableDataUD () {
      return this.$store.state.results[0] ? 
        this.$store.state.UDarr.map(element => {
          let row =  element.split('\t')
          const mrophObj = {
            id: row[0],
            word: row[1],          
            lemma: row[2],
            lemmaVocalized: row[6],
            upos: row[3],
            //xpos: row[4],
            features: row[5] && row[5].length > 1 ? row[5].split('|') : row[5]
          }
          return mrophObj
        })
      : []
    },
    tableDataFiltered () {
      return this.tableDataBGU.filter(item=>  {
        //return item.lex && item.lex.length > 0
        return item.POS
      })  
    },
    textStyle () {
      let txt = ''
      let textStyleOptionsHe = 
      ['טקסט מודרני',
        'טקסט קדם-מודרני',
        'טקסט רבני'
      ]
      let textStyleOptions = [
        'Modern text',
        'Pre-modern text',
        'Rabbinic text'
      ] 
      switch (this.$store.state.textStyle) {
        case 'modern':
          txt = this.hebrew ? textStyleOptionsHe[0] : textStyleOptions[0]
          break;
        case 'premodern': 
          txt = this.hebrew ? textStyleOptionsHe[1] : textStyleOptions[1] 
          break;
        case 'rabbinic':
          txt = this.hebrew ? textStyleOptionsHe[2] : textStyleOptions[2] 
          break;
      }
      return txt
    }
  },  
  methods: {
    capitalize(word) {
      if (word && word.length > 0) {
        return word[0].toUpperCase() + word.substring(1).toLowerCase()
      }  
      return ''  
    }
  }
}
</script>

<style lang="scss" >
  .result-table-wrap {  
    border-radius: 6px;
    .ud-format {
      height: 70vh;
      overflow-y: scroll;
    }
    table {
      border-collapse: separate!important;
    }    
    thead {
      //box-shadow: 0 2px 5px 0 rgba(116, 116, 116, 0.25);
    }
    tr {      
      &:hover {
        background-color: #d6ecff!important;
      }
      &:nth-of-type(odd) {
        background-color: #f6f6f6;
     }
    }
    th {
      &.sticky {
        position: sticky;
        right: 0;
        z-index: 4!important;
      }
    }  
    td {
      border-top: none;
      min-height: 36px;
      vertical-align: middle;     
      &.f-narkis {
        font-size: 20px;       
      }      
      &.b-table-sticky-column {
        right: 0!important;
        background-color: #e3e3e3!important;
        min-width: 95px;
      }
      .prefix {
        color: #ba8686;
        .prefix-line {
          margin:0 2px;
        }
      }
      .feature-item {
        font-size: 13px;
      }
    }  
  }
  
</style>
